__turbopack_context__.v({
  "buttonsContainer": "UserMenuComponents-module__b4UszW__buttonsContainer",
  "mailLabel": "UserMenuComponents-module__b4UszW__mailLabel",
  "menuButtonContainer": "UserMenuComponents-module__b4UszW__menuButtonContainer",
  "menuButtonIcon": "UserMenuComponents-module__b4UszW__menuButtonIcon",
  "menuButtonIconContainer": "UserMenuComponents-module__b4UszW__menuButtonIconContainer",
  "menuButtonLabel": "UserMenuComponents-module__b4UszW__menuButtonLabel",
  "userContainer": "UserMenuComponents-module__b4UszW__userContainer",
  "usernameLabel": "UserMenuComponents-module__b4UszW__usernameLabel",
});
